<template>
  <h1>Live Map</h1>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>
